/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createShopSettings = /* GraphQL */ `
  mutation CreateShopSettings(
    $input: CreateShopSettingsInput!
    $condition: ModelShopSettingsConditionInput
  ) {
    createShopSettings(input: $input, condition: $condition) {
      id
      locationId
      currentRO
      settingsJson
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateShopSettings = /* GraphQL */ `
  mutation UpdateShopSettings(
    $input: UpdateShopSettingsInput!
    $condition: ModelShopSettingsConditionInput
  ) {
    updateShopSettings(input: $input, condition: $condition) {
      id
      locationId
      currentRO
      settingsJson
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteShopSettings = /* GraphQL */ `
  mutation DeleteShopSettings(
    $input: DeleteShopSettingsInput!
    $condition: ModelShopSettingsConditionInput
  ) {
    deleteShopSettings(input: $input, condition: $condition) {
      id
      locationId
      currentRO
      settingsJson
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBay = /* GraphQL */ `
  mutation CreateBay(
    $input: CreateBayInput!
    $condition: ModelBayConditionInput
  ) {
    createBay(input: $input, condition: $condition) {
      id
      locationId
      shopId
      bayNumber
      label
      type
      zone
      x
      y
      width
      height
      active
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBay = /* GraphQL */ `
  mutation UpdateBay(
    $input: UpdateBayInput!
    $condition: ModelBayConditionInput
  ) {
    updateBay(input: $input, condition: $condition) {
      id
      locationId
      shopId
      bayNumber
      label
      type
      zone
      x
      y
      width
      height
      active
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBay = /* GraphQL */ `
  mutation DeleteBay(
    $input: DeleteBayInput!
    $condition: ModelBayConditionInput
  ) {
    deleteBay(input: $input, condition: $condition) {
      id
      locationId
      shopId
      bayNumber
      label
      type
      zone
      x
      y
      width
      height
      active
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTruck = /* GraphQL */ `
  mutation CreateTruck(
    $input: CreateTruckInput!
    $condition: ModelTruckConditionInput
  ) {
    createTruck(input: $input, condition: $condition) {
      id
      locationId
      repairOrder
      companyName
      truckNumber
      reason
      status
      position
      techNumbers
      warranty
      contactPerson
      phone
      email
      partsHandling
      customerCheckInId
      year
      make
      model
      vin
      mileage
      hours
      faults
      startTime
      lastStatusChange
      lastNote
      timeInWip
      wipStartTime
      isPaused
      notes
      statusHistory {
        status
        timeEntered
        __typename
      }
      serviceSummary
      repairCategories {
        category
        subcategory
        estimatedTime
        completionTime
        __typename
      }
      repairCategory
      repairSubcategory
      estimatedTime
      completionTime
      expired
      warning
      critical
      completionType
      bayId
      location
      priorityScore
      slaRisk
      downtimeSeverity
      isHardDown
      fleetId
      fleetPriority
      flaggedHours
      partsStatus
      partsEta
      estimatedCompletion
      promisedTime
      blockers {
        type
        description
        since
        resolvedAt
        __typename
      }
      activities {
        id
        type
        text
        author
        timestamp
        photos
        customerFacing
        category
        stage
        __typename
      }
      currentBlocker {
        type
        description
        setBy
        setAt
        resolvedAt
        resolvedBy
        owner
        __typename
      }
      blockerHistory {
        type
        description
        setBy
        setAt
        resolvedAt
        resolvedBy
        owner
        __typename
      }
      laborType
      customerType
      shopId
      parts {
        id
        description
        partNumber
        vendor
        quantity
        cost
        price
        status
        orderedAt
        receivedAt
        eta
        notes
        addedBy
        addedAt
        __typename
      }
      estimates {
        id
        truckId
        roNumber
        status
        shopSupplies
        shopSuppliesPct
        taxRate
        subtotal
        tax
        total
        notes
        customerNotes
        token
        sentAt
        approvedAt
        approvalMethod
        approvedBy
        approvalNotes
        declinedAt
        declineReason
        invoicedAt
        lockedAt
        paymentTermsDays
        createdBy
        createdAt
        updatedAt
        version
        __typename
      }
      customerId
      unitId
      poNumber
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTruck = /* GraphQL */ `
  mutation UpdateTruck(
    $input: UpdateTruckInput!
    $condition: ModelTruckConditionInput
  ) {
    updateTruck(input: $input, condition: $condition) {
      id
      locationId
      repairOrder
      companyName
      truckNumber
      reason
      status
      position
      techNumbers
      warranty
      contactPerson
      phone
      email
      partsHandling
      customerCheckInId
      year
      make
      model
      vin
      mileage
      hours
      faults
      startTime
      lastStatusChange
      lastNote
      timeInWip
      wipStartTime
      isPaused
      notes
      statusHistory {
        status
        timeEntered
        __typename
      }
      serviceSummary
      repairCategories {
        category
        subcategory
        estimatedTime
        completionTime
        __typename
      }
      repairCategory
      repairSubcategory
      estimatedTime
      completionTime
      expired
      warning
      critical
      completionType
      bayId
      location
      priorityScore
      slaRisk
      downtimeSeverity
      isHardDown
      fleetId
      fleetPriority
      flaggedHours
      partsStatus
      partsEta
      estimatedCompletion
      promisedTime
      blockers {
        type
        description
        since
        resolvedAt
        __typename
      }
      activities {
        id
        type
        text
        author
        timestamp
        photos
        customerFacing
        category
        stage
        __typename
      }
      currentBlocker {
        type
        description
        setBy
        setAt
        resolvedAt
        resolvedBy
        owner
        __typename
      }
      blockerHistory {
        type
        description
        setBy
        setAt
        resolvedAt
        resolvedBy
        owner
        __typename
      }
      laborType
      customerType
      shopId
      parts {
        id
        description
        partNumber
        vendor
        quantity
        cost
        price
        status
        orderedAt
        receivedAt
        eta
        notes
        addedBy
        addedAt
        __typename
      }
      estimates {
        id
        truckId
        roNumber
        status
        shopSupplies
        shopSuppliesPct
        taxRate
        subtotal
        tax
        total
        notes
        customerNotes
        token
        sentAt
        approvedAt
        approvalMethod
        approvedBy
        approvalNotes
        declinedAt
        declineReason
        invoicedAt
        lockedAt
        paymentTermsDays
        createdBy
        createdAt
        updatedAt
        version
        __typename
      }
      customerId
      unitId
      poNumber
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTruck = /* GraphQL */ `
  mutation DeleteTruck(
    $input: DeleteTruckInput!
    $condition: ModelTruckConditionInput
  ) {
    deleteTruck(input: $input, condition: $condition) {
      id
      locationId
      repairOrder
      companyName
      truckNumber
      reason
      status
      position
      techNumbers
      warranty
      contactPerson
      phone
      email
      partsHandling
      customerCheckInId
      year
      make
      model
      vin
      mileage
      hours
      faults
      startTime
      lastStatusChange
      lastNote
      timeInWip
      wipStartTime
      isPaused
      notes
      statusHistory {
        status
        timeEntered
        __typename
      }
      serviceSummary
      repairCategories {
        category
        subcategory
        estimatedTime
        completionTime
        __typename
      }
      repairCategory
      repairSubcategory
      estimatedTime
      completionTime
      expired
      warning
      critical
      completionType
      bayId
      location
      priorityScore
      slaRisk
      downtimeSeverity
      isHardDown
      fleetId
      fleetPriority
      flaggedHours
      partsStatus
      partsEta
      estimatedCompletion
      promisedTime
      blockers {
        type
        description
        since
        resolvedAt
        __typename
      }
      activities {
        id
        type
        text
        author
        timestamp
        photos
        customerFacing
        category
        stage
        __typename
      }
      currentBlocker {
        type
        description
        setBy
        setAt
        resolvedAt
        resolvedBy
        owner
        __typename
      }
      blockerHistory {
        type
        description
        setBy
        setAt
        resolvedAt
        resolvedBy
        owner
        __typename
      }
      laborType
      customerType
      shopId
      parts {
        id
        description
        partNumber
        vendor
        quantity
        cost
        price
        status
        orderedAt
        receivedAt
        eta
        notes
        addedBy
        addedAt
        __typename
      }
      estimates {
        id
        truckId
        roNumber
        status
        shopSupplies
        shopSuppliesPct
        taxRate
        subtotal
        tax
        total
        notes
        customerNotes
        token
        sentAt
        approvedAt
        approvalMethod
        approvedBy
        approvalNotes
        declinedAt
        declineReason
        invoicedAt
        lockedAt
        paymentTermsDays
        createdBy
        createdAt
        updatedAt
        version
        __typename
      }
      customerId
      unitId
      poNumber
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCustomer = /* GraphQL */ `
  mutation CreateCustomer(
    $input: CreateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    createCustomer(input: $input, condition: $condition) {
      id
      shopId
      name
      contactPerson
      phone
      email
      customerType
      fleetId
      partsHandling
      paymentTermsDays
      warranty
      notes
      poRequired
      creditHold
      creditHoldNote
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer(
    $input: UpdateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    updateCustomer(input: $input, condition: $condition) {
      id
      shopId
      name
      contactPerson
      phone
      email
      customerType
      fleetId
      partsHandling
      paymentTermsDays
      warranty
      notes
      poRequired
      creditHold
      creditHoldNote
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer(
    $input: DeleteCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    deleteCustomer(input: $input, condition: $condition) {
      id
      shopId
      name
      contactPerson
      phone
      email
      customerType
      fleetId
      partsHandling
      paymentTermsDays
      warranty
      notes
      poRequired
      creditHold
      creditHoldNote
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUnit = /* GraphQL */ `
  mutation CreateUnit(
    $input: CreateUnitInput!
    $condition: ModelUnitConditionInput
  ) {
    createUnit(input: $input, condition: $condition) {
      id
      shopId
      customerId
      vin
      unitNumber
      year
      make
      model
      mileage
      hours
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUnit = /* GraphQL */ `
  mutation UpdateUnit(
    $input: UpdateUnitInput!
    $condition: ModelUnitConditionInput
  ) {
    updateUnit(input: $input, condition: $condition) {
      id
      shopId
      customerId
      vin
      unitNumber
      year
      make
      model
      mileage
      hours
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUnit = /* GraphQL */ `
  mutation DeleteUnit(
    $input: DeleteUnitInput!
    $condition: ModelUnitConditionInput
  ) {
    deleteUnit(input: $input, condition: $condition) {
      id
      shopId
      customerId
      vin
      unitNumber
      year
      make
      model
      mileage
      hours
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createColumnTimeout = /* GraphQL */ `
  mutation CreateColumnTimeout(
    $input: CreateColumnTimeoutInput!
    $condition: ModelColumnTimeoutConditionInput
  ) {
    createColumnTimeout(input: $input, condition: $condition) {
      id
      columnId
      limit
      warning
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateColumnTimeout = /* GraphQL */ `
  mutation UpdateColumnTimeout(
    $input: UpdateColumnTimeoutInput!
    $condition: ModelColumnTimeoutConditionInput
  ) {
    updateColumnTimeout(input: $input, condition: $condition) {
      id
      columnId
      limit
      warning
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteColumnTimeout = /* GraphQL */ `
  mutation DeleteColumnTimeout(
    $input: DeleteColumnTimeoutInput!
    $condition: ModelColumnTimeoutConditionInput
  ) {
    deleteColumnTimeout(input: $input, condition: $condition) {
      id
      columnId
      limit
      warning
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTechnician = /* GraphQL */ `
  mutation CreateTechnician(
    $input: CreateTechnicianInput!
    $condition: ModelTechnicianConditionInput
  ) {
    createTechnician(input: $input, condition: $condition) {
      id
      locationId
      name
      number
      specialties
      active
      currentLoad
      completionRate
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTechnician = /* GraphQL */ `
  mutation UpdateTechnician(
    $input: UpdateTechnicianInput!
    $condition: ModelTechnicianConditionInput
  ) {
    updateTechnician(input: $input, condition: $condition) {
      id
      locationId
      name
      number
      specialties
      active
      currentLoad
      completionRate
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTechnician = /* GraphQL */ `
  mutation DeleteTechnician(
    $input: DeleteTechnicianInput!
    $condition: ModelTechnicianConditionInput
  ) {
    deleteTechnician(input: $input, condition: $condition) {
      id
      locationId
      name
      number
      specialties
      active
      currentLoad
      completionRate
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCustomerCheckIn = /* GraphQL */ `
  mutation CreateCustomerCheckIn(
    $input: CreateCustomerCheckInInput!
    $condition: ModelCustomerCheckInConditionInput
  ) {
    createCustomerCheckIn(input: $input, condition: $condition) {
      id
      locationId
      companyName
      contactPerson
      phone
      email
      serviceReason
      partsHandling
      signatureImage
      agreementConfirmed
      status
      timestamp
      createdAt
      updatedAt
      vehicleYear
      vehicleMake
      vehicleModel
      vehicleVin
      vehicleMileage
      vehicleEngineHours
      vehicleFaults
      __typename
    }
  }
`;
export const updateCustomerCheckIn = /* GraphQL */ `
  mutation UpdateCustomerCheckIn(
    $input: UpdateCustomerCheckInInput!
    $condition: ModelCustomerCheckInConditionInput
  ) {
    updateCustomerCheckIn(input: $input, condition: $condition) {
      id
      locationId
      companyName
      contactPerson
      phone
      email
      serviceReason
      partsHandling
      signatureImage
      agreementConfirmed
      status
      timestamp
      createdAt
      updatedAt
      vehicleYear
      vehicleMake
      vehicleModel
      vehicleVin
      vehicleMileage
      vehicleEngineHours
      vehicleFaults
      __typename
    }
  }
`;
export const deleteCustomerCheckIn = /* GraphQL */ `
  mutation DeleteCustomerCheckIn(
    $input: DeleteCustomerCheckInInput!
    $condition: ModelCustomerCheckInConditionInput
  ) {
    deleteCustomerCheckIn(input: $input, condition: $condition) {
      id
      locationId
      companyName
      contactPerson
      phone
      email
      serviceReason
      partsHandling
      signatureImage
      agreementConfirmed
      status
      timestamp
      createdAt
      updatedAt
      vehicleYear
      vehicleMake
      vehicleModel
      vehicleVin
      vehicleMileage
      vehicleEngineHours
      vehicleFaults
      __typename
    }
  }
`;
export const createRepairEvent = /* GraphQL */ `
  mutation CreateRepairEvent(
    $input: CreateRepairEventInput!
    $condition: ModelRepairEventConditionInput
  ) {
    createRepairEvent(input: $input, condition: $condition) {
      id
      locationId
      shopId
      roNumber
      sourceTruckId
      vin
      unitNumber
      engineFamily
      make
      model
      year
      classificationId
      quotedLaborHours
      actualLaborHours
      completedAt
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRepairEvent = /* GraphQL */ `
  mutation UpdateRepairEvent(
    $input: UpdateRepairEventInput!
    $condition: ModelRepairEventConditionInput
  ) {
    updateRepairEvent(input: $input, condition: $condition) {
      id
      locationId
      shopId
      roNumber
      sourceTruckId
      vin
      unitNumber
      engineFamily
      make
      model
      year
      classificationId
      quotedLaborHours
      actualLaborHours
      completedAt
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRepairEvent = /* GraphQL */ `
  mutation DeleteRepairEvent(
    $input: DeleteRepairEventInput!
    $condition: ModelRepairEventConditionInput
  ) {
    deleteRepairEvent(input: $input, condition: $condition) {
      id
      locationId
      shopId
      roNumber
      sourceTruckId
      vin
      unitNumber
      engineFamily
      make
      model
      year
      classificationId
      quotedLaborHours
      actualLaborHours
      completedAt
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLaborAggregate = /* GraphQL */ `
  mutation CreateLaborAggregate(
    $input: CreateLaborAggregateInput!
    $condition: ModelLaborAggregateConditionInput
  ) {
    createLaborAggregate(input: $input, condition: $condition) {
      id
      scope
      scopeId
      classificationId
      count
      sumHours
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const updateLaborAggregate = /* GraphQL */ `
  mutation UpdateLaborAggregate(
    $input: UpdateLaborAggregateInput!
    $condition: ModelLaborAggregateConditionInput
  ) {
    updateLaborAggregate(input: $input, condition: $condition) {
      id
      scope
      scopeId
      classificationId
      count
      sumHours
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const deleteLaborAggregate = /* GraphQL */ `
  mutation DeleteLaborAggregate(
    $input: DeleteLaborAggregateInput!
    $condition: ModelLaborAggregateConditionInput
  ) {
    deleteLaborAggregate(input: $input, condition: $condition) {
      id
      scope
      scopeId
      classificationId
      count
      sumHours
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const createOperationEvent = /* GraphQL */ `
  mutation CreateOperationEvent(
    $input: CreateOperationEventInput!
    $condition: ModelOperationEventConditionInput
  ) {
    createOperationEvent(input: $input, condition: $condition) {
      id
      eventType
      timestamp
      locationId
      assetId
      workOrderId
      technicianId
      userId
      previousStatus
      newStatus
      note
      relatedPhotoIds
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOperationEvent = /* GraphQL */ `
  mutation UpdateOperationEvent(
    $input: UpdateOperationEventInput!
    $condition: ModelOperationEventConditionInput
  ) {
    updateOperationEvent(input: $input, condition: $condition) {
      id
      eventType
      timestamp
      locationId
      assetId
      workOrderId
      technicianId
      userId
      previousStatus
      newStatus
      note
      relatedPhotoIds
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOperationEvent = /* GraphQL */ `
  mutation DeleteOperationEvent(
    $input: DeleteOperationEventInput!
    $condition: ModelOperationEventConditionInput
  ) {
    deleteOperationEvent(input: $input, condition: $condition) {
      id
      eventType
      timestamp
      locationId
      assetId
      workOrderId
      technicianId
      userId
      previousStatus
      newStatus
      note
      relatedPhotoIds
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRoadServiceCall = /* GraphQL */ `
  mutation CreateRoadServiceCall(
    $input: CreateRoadServiceCallInput!
    $condition: ModelRoadServiceCallConditionInput
  ) {
    createRoadServiceCall(input: $input, condition: $condition) {
      id
      customerId
      assetId
      locationId
      customerName
      companyName
      contactName
      callbackPhone
      unitNumber
      vin
      complaint
      roadServiceAddress
      destinationLatitude
      destinationLongitude
      vehicleYear
      vehicleMake
      vehicleModel
      vehicleColor
      priority
      assignedTechnicianId
      assignedServiceTruckId
      status
      workOrderId
      dispatchedAt
      travelStartedAt
      arrivedAt
      workStartedAt
      completedAt
      cancelledAt
      acceptedAt
      acceptedByTechnicianId
      holdStartedAt
      currentHoldReason
      currentHoldNote
      holdResumeStatus
      returnedAt
      odometerOut
      odometerReturn
      billedMiles
      billedHours
      billingNote
      customerSignatureUrl
      locationRequestToken
      locationRequestPhone
      locationRequestedAt
      locationReceivedAt
      locationRequestStatus
      locationSource
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRoadServiceCall = /* GraphQL */ `
  mutation UpdateRoadServiceCall(
    $input: UpdateRoadServiceCallInput!
    $condition: ModelRoadServiceCallConditionInput
  ) {
    updateRoadServiceCall(input: $input, condition: $condition) {
      id
      customerId
      assetId
      locationId
      customerName
      companyName
      contactName
      callbackPhone
      unitNumber
      vin
      complaint
      roadServiceAddress
      destinationLatitude
      destinationLongitude
      vehicleYear
      vehicleMake
      vehicleModel
      vehicleColor
      priority
      assignedTechnicianId
      assignedServiceTruckId
      status
      workOrderId
      dispatchedAt
      travelStartedAt
      arrivedAt
      workStartedAt
      completedAt
      cancelledAt
      acceptedAt
      acceptedByTechnicianId
      holdStartedAt
      currentHoldReason
      currentHoldNote
      holdResumeStatus
      returnedAt
      odometerOut
      odometerReturn
      billedMiles
      billedHours
      billingNote
      customerSignatureUrl
      locationRequestToken
      locationRequestPhone
      locationRequestedAt
      locationReceivedAt
      locationRequestStatus
      locationSource
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRoadServiceCall = /* GraphQL */ `
  mutation DeleteRoadServiceCall(
    $input: DeleteRoadServiceCallInput!
    $condition: ModelRoadServiceCallConditionInput
  ) {
    deleteRoadServiceCall(input: $input, condition: $condition) {
      id
      customerId
      assetId
      locationId
      customerName
      companyName
      contactName
      callbackPhone
      unitNumber
      vin
      complaint
      roadServiceAddress
      destinationLatitude
      destinationLongitude
      vehicleYear
      vehicleMake
      vehicleModel
      vehicleColor
      priority
      assignedTechnicianId
      assignedServiceTruckId
      status
      workOrderId
      dispatchedAt
      travelStartedAt
      arrivedAt
      workStartedAt
      completedAt
      cancelledAt
      acceptedAt
      acceptedByTechnicianId
      holdStartedAt
      currentHoldReason
      currentHoldNote
      holdResumeStatus
      returnedAt
      odometerOut
      odometerReturn
      billedMiles
      billedHours
      billingNote
      customerSignatureUrl
      locationRequestToken
      locationRequestPhone
      locationRequestedAt
      locationReceivedAt
      locationRequestStatus
      locationSource
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRoadServiceStatusEvent = /* GraphQL */ `
  mutation CreateRoadServiceStatusEvent(
    $input: CreateRoadServiceStatusEventInput!
    $condition: ModelRoadServiceStatusEventConditionInput
  ) {
    createRoadServiceStatusEvent(input: $input, condition: $condition) {
      id
      roadServiceCallId
      locationId
      status
      fromStatus
      at
      technicianId
      techNumber
      techName
      holdReason
      holdNote
      resumeStatus
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRoadServiceStatusEvent = /* GraphQL */ `
  mutation UpdateRoadServiceStatusEvent(
    $input: UpdateRoadServiceStatusEventInput!
    $condition: ModelRoadServiceStatusEventConditionInput
  ) {
    updateRoadServiceStatusEvent(input: $input, condition: $condition) {
      id
      roadServiceCallId
      locationId
      status
      fromStatus
      at
      technicianId
      techNumber
      techName
      holdReason
      holdNote
      resumeStatus
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRoadServiceStatusEvent = /* GraphQL */ `
  mutation DeleteRoadServiceStatusEvent(
    $input: DeleteRoadServiceStatusEventInput!
    $condition: ModelRoadServiceStatusEventConditionInput
  ) {
    deleteRoadServiceStatusEvent(input: $input, condition: $condition) {
      id
      roadServiceCallId
      locationId
      status
      fromStatus
      at
      technicianId
      techNumber
      techName
      holdReason
      holdNote
      resumeStatus
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTimeEntry = /* GraphQL */ `
  mutation CreateTimeEntry(
    $input: CreateTimeEntryInput!
    $condition: ModelTimeEntryConditionInput
  ) {
    createTimeEntry(input: $input, condition: $condition) {
      id
      locationId
      workOrderId
      roadServiceCallId
      technicianId
      techNumber
      techName
      kind
      startedAt
      endedAt
      seconds
      billedAt
      billedEstimateId
      note
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTimeEntry = /* GraphQL */ `
  mutation UpdateTimeEntry(
    $input: UpdateTimeEntryInput!
    $condition: ModelTimeEntryConditionInput
  ) {
    updateTimeEntry(input: $input, condition: $condition) {
      id
      locationId
      workOrderId
      roadServiceCallId
      technicianId
      techNumber
      techName
      kind
      startedAt
      endedAt
      seconds
      billedAt
      billedEstimateId
      note
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTimeEntry = /* GraphQL */ `
  mutation DeleteTimeEntry(
    $input: DeleteTimeEntryInput!
    $condition: ModelTimeEntryConditionInput
  ) {
    deleteTimeEntry(input: $input, condition: $condition) {
      id
      locationId
      workOrderId
      roadServiceCallId
      technicianId
      techNumber
      techName
      kind
      startedAt
      endedAt
      seconds
      billedAt
      billedEstimateId
      note
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTechnicianLocation = /* GraphQL */ `
  mutation CreateTechnicianLocation(
    $input: CreateTechnicianLocationInput!
    $condition: ModelTechnicianLocationConditionInput
  ) {
    createTechnicianLocation(input: $input, condition: $condition) {
      id
      technicianId
      userId
      locationId
      latitude
      longitude
      accuracy
      heading
      speed
      timestamp
      source
      activeRoadServiceCallId
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTechnicianLocation = /* GraphQL */ `
  mutation UpdateTechnicianLocation(
    $input: UpdateTechnicianLocationInput!
    $condition: ModelTechnicianLocationConditionInput
  ) {
    updateTechnicianLocation(input: $input, condition: $condition) {
      id
      technicianId
      userId
      locationId
      latitude
      longitude
      accuracy
      heading
      speed
      timestamp
      source
      activeRoadServiceCallId
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTechnicianLocation = /* GraphQL */ `
  mutation DeleteTechnicianLocation(
    $input: DeleteTechnicianLocationInput!
    $condition: ModelTechnicianLocationConditionInput
  ) {
    deleteTechnicianLocation(input: $input, condition: $condition) {
      id
      technicianId
      userId
      locationId
      latitude
      longitude
      accuracy
      heading
      speed
      timestamp
      source
      activeRoadServiceCallId
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
